import DefaultHome from "src/components/feature/Home";

const Home = () => {
  return <DefaultHome />;
};

export default Home;
